// extracted by mini-css-extract-plugin
module.exports = {"button":"_1XmTt","wrapper":"ORjwd","label":"eZ6Bz"};